module.exports = __webpack_public_path__ + "img/github-light.ef7a02b6.png";